// vant 国际化
import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import tlPH from './vant/tl-PH';
 
function changeLang(newlang) {
  switch (newlang) {
    case 'tl-PH':
      Locale.use(newlang, tlPH);
      localStorage.setItem('i18n', newlang)
      break;
    default:
      Locale.use('en-US', enUS);
      localStorage.setItem('i18n', 'en-US')
      break;
  }
}
 
export function Local(mylang) {
  changeLang(mylang)
}